import React, { useEffect, useState } from 'react';

import { DocumentsSections } from '@cd3p/core/modules/documents';
import { APILanguage } from '@cd3p/core/types/api';

import { i18n, useParams, useSelector, useTranslation } from 'third-party';

import { termsAndConditionsEditorUrl } from 'constants/url';

import { useTermsAndConditions } from 'modules/termsAndConditions';

import { termsAndConditionsSelectors } from 'selectors';

import { DocsEditor } from 'features/Docs/DocsEditor';

const applicationsOptions = [
  {
    label: i18n.t('docs.applications.termsWebDispatcher'),
    value: DocumentsSections.TermsAndConditionsWebDispatcher,
  },
  {
    label: i18n.t('docs.applications.termsWebContractor'),
    value: DocumentsSections.TermsAndConditionsWebContractor,
  },
  {
    label: i18n.t('docs.applications.termsMobileContractor'),
    value: DocumentsSections.TermsAndConditionsMobileContractor,
  },
  {
    label: i18n.t('docs.applications.termsLanding'),
    value: DocumentsSections.TermsAndConditionsLanding,
  },
];

const treeProps = {
  rowHeight: 30,
  hasSections: false,
};

export const TermsAndConditionsEditor = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState<APILanguage>(APILanguage.English);

  const { applicationId, documentId } = useParams();

  const {
    loadTermsAndConditionsDocuments,
    fetchTermsAndConditionsDocument,
    saveTermsAndConditionsDocument,
    deleteTermsAndConditionsDocument,
    resetTermsAndConditions,
  } = useTermsAndConditions(applicationId as DocumentsSections, language);

  const items = useSelector(
    termsAndConditionsSelectors.termsAndConditionsItemsTree,
  );
  const itemsLoading = useSelector(
    termsAndConditionsSelectors.termsAndConditionsItemsLoading,
  );
  const itemsLoaded = useSelector(
    termsAndConditionsSelectors.termsAndConditionsItemsLoaded,
  );
  const documentLoading = useSelector(
    termsAndConditionsSelectors.fetchTermsAndConditionsDocumentPending,
  );

  useEffect(() => {
    return () => {
      resetTermsAndConditions();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DocsEditor
      title={t('helpCenter.title')}
      applicationId={applicationId as DocumentsSections}
      documentId={documentId}
      items={items}
      itemsLoading={itemsLoading}
      itemsLoaded={itemsLoaded}
      documentLoading={documentLoading}
      loadDocuments={loadTermsAndConditionsDocuments}
      saveDocument={saveTermsAndConditionsDocument}
      deleteDocument={deleteTermsAndConditionsDocument}
      fetchDocument={fetchTermsAndConditionsDocument}
      editorUrl={termsAndConditionsEditorUrl}
      language={language}
      setLanguage={setLanguage}
      applications={applicationsOptions}
      treeProps={treeProps}
    />
  );
};
